export default "/images/framework/Badge_10.38d6adf8.svg?38d6adf8";